package com.tovtalk.utils.language

object LanguageCodes {
    const val ENGLISH = "en"
    const val HEBREW = "he"
    val RTL_LANGUAGES = setOf(HEBREW)
    fun isRtl(languageCode: String): Boolean = languageCode in RTL_LANGUAGES
}
